import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getWorklineStatements() {
  const data = await apiGet('sof/workStatements');
  useHelperStore().setWorklineStatements(data);
}
